<template>
  <div
    v-if="itemList"
    class="page has-background-blue with-title"
  >
    <h1 class="page-title has-text-weight-bold has-text-centered is-size-5">
      {{ section_title }}
    </h1>
    <div class="container p-4">
      <div class="columns is-multiline is-mobile">
        <GenericMosaicItem
          v-for="item in itemList"
          :key="item.id"
          :data="item"
          @click="openContent(item)"
        />
        <div
          v-if="emptyResult"
          class="column is-12-mobile is-6-tablet is-offset-3-tablet"
        >
          <div class="no-results">
            No se han encontrado resultados.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import GenericMosaicItem from "@/components/lists/GenericMosaicItem";

export default {
  name: 'VideosGalleryList',
  components: {GenericMosaicItem},
  title: 'Videos',
  data: function () {
    return {
      section_title: 'Vídeos',
      itemList: null
    }
  },
  computed: {
    emptyResult() {
      if (!this.itemList) {
        return false
      }

      return this.itemList.length === 0
    },
    userToken() {
      return this.$store.state.token
    }
  },
  watch: {
    userToken() {
      this.loadContent()
    }
  },
  mounted() {
    console.log("mounted")
    this.loadContent()
  },
  methods: {
    async loadContent() {
      try {
        await this.$store.dispatch('initLoading')

        this.itemList = await this.$api.video.getList()

        await this.$store.dispatch('finishLoading')
      } catch (error) {
        await this.$store.dispatch('finishLoading')

        await this.handleContentError(error)
      }
    },
    openContent(item) {
      const galleryId = item.id
      this.$router.push({name: "videos-gallery", params: {galleryId}})
    }
  }
}
</script>
